module.exports = __webpack_public_path__ + "img/微信钱包.0d2716fe.svg";